import { Controller } from 'stimulus'
import DmRequestAuditHistoryModule, { buildAuditHistoryJsonUrl } from './shared_modules/dm_request_audit_history_module.js'

export default class extends Controller {
  static targets = [
    'auditHistory',
    'changeSummary',
    'changeSummaryBlock',
    'changeSummarySection',
    'changeSummaryChevron',
    'auditHistoryBlock',
    'auditHistorySection',
    'auditHistoryChevron'
  ]

  connect () {
    this.loaded = false
    this.loadingPromise = null
  }

  async toggleChangeSummary (event) {
    event.preventDefault()
    await this.toggleSection({
      section: this.changeSummarySectionTarget,
      chevron: this.changeSummaryChevronTarget,
      button: event.currentTarget,
      content: this.changeSummaryTarget,
      loadingMessage: 'Loading change summary...'
    })
  }

  async toggleAuditHistory (event) {
    event.preventDefault()
    await this.toggleSection({
      section: this.auditHistorySectionTarget,
      chevron: this.auditHistoryChevronTarget,
      button: event.currentTarget,
      content: this.auditHistoryTarget,
      loadingMessage: 'Loading audit history...'
    })
  }

  async toggleSection ({ section, chevron, button, content, loadingMessage }) {
    const willExpand = section.classList.contains('hidden')

    if (!willExpand) {
      section.classList.add('hidden')
      chevron.style.transform = 'rotate(0deg)'
      button.setAttribute('aria-expanded', 'false')
      return
    }

    section.classList.remove('hidden')
    chevron.style.transform = 'rotate(180deg)'
    button.setAttribute('aria-expanded', 'true')

    if (!this.loaded) {
      content.innerHTML = `<p class="text-sm text-gray-500 italic">${loadingMessage}</p>`
      await this.ensureLoaded()
    }
  }

  async ensureLoaded () {
    if (this.loaded) return
    if (this.loadingPromise) return this.loadingPromise

    const auditHistoryPath = this.data.get('auditHistoryUrl')
    if (!auditHistoryPath) return

    this.loadingPromise = this.loadAuditData(auditHistoryPath)
    await this.loadingPromise
    this.loaded = true
  }

  async loadAuditData (auditHistoryPath) {
    this.auditHistoryModule = new DmRequestAuditHistoryModule({
      auditHistoryUrl: buildAuditHistoryJsonUrl(auditHistoryPath),
      auditHistoryTarget: this.auditHistoryTarget,
      changeSummaryTarget: this.hasChangeSummaryTarget ? this.changeSummaryTarget : null
    })

    await this.auditHistoryModule.load()
    this.syncChangeSummaryVisibility()
  }

  syncChangeSummaryVisibility () {
    if (!this.hasChangeSummaryBlockTarget || !this.hasChangeSummaryTarget) return

    const hasContent = this.changeSummaryTarget.innerHTML.trim().length > 0 &&
      !this.changeSummaryTarget.classList.contains('hidden')

    if (hasContent) {
      this.changeSummaryBlockTarget.classList.remove('hidden')
    } else {
      this.changeSummaryBlockTarget.classList.add('hidden')
      this.changeSummarySectionTarget.classList.add('hidden')
      if (this.hasChangeSummaryChevronTarget) {
        this.changeSummaryChevronTarget.style.transform = 'rotate(0deg)'
      }
    }
  }
}
